import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { LocalizePipe } from '@shared/common/pipes/localize.pipe';
import { PermissionCheckerService } from 'abp-ng2-module';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as objectPath from 'object-path';
import { filter } from 'rxjs/operators';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { AppNavigationService } from './app-navigation.service';

@Component({
    selector: 'top-bar-menu-upm',
    templateUrl: './top-bar-menu-upm.component.html',
    styleUrls: ['./top-bar-menu-upm.component.less'],
    imports: [
    NgTemplateOutlet,
    RouterLinkActive,
    RouterLink,
    NgClass,
    LocalizePipe
],
})
export class TopBarMenuUpmComponent extends AppComponentBase implements OnInit, AfterViewInit {

  @Input() isTabMenuUsed?: boolean;

  @Output() changeTopbarItem: EventEmitter<AppMenuItem> = new EventEmitter<AppMenuItem>(true);

  public isDesktop: boolean;

  menu: AppMenu = null;
  currentRouteUrl: any = '';
  menuDepth: 0;

  @ViewChild('kt_header_menu' , { static: true }) el: ElementRef;

  

  constructor(
    injector: Injector,
    private router: Router,
    public permission: PermissionCheckerService,
    private deviceService: DeviceDetectorService,
    private _appNavigationService: AppNavigationService) {
    super(injector);
  }

  ngOnInit() {
    this.menu = this._appNavigationService.getMenu();
    console.log(this.menu, "menu");
    this.defineSize(window.innerWidth);
    this.currentRouteUrl = this.router.url;
    let topItem = this.findActiveTopMenu(this.currentRouteUrl, this.menu.items)
    this.changeTopbarItem.emit(topItem);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.currentRouteUrl = this.router.url;
      });
  }

  ngAfterViewInit(): void {
  }

  showMenuItem(menuItem): boolean {
    return this._appNavigationService.showMenuItem(menuItem);
  }

  getItemCssClasses(item, parentItem, depth) {
    let isRootLevel = item && !parentItem;

    let cssClasses = 'kt-menu__item';

    if (objectPath.get(item, 'items.length') || this.isRootTabMenuItemWithoutChildren(item, isRootLevel)) {
      cssClasses += ' kt-menu__item--submenu';
    }

    if (objectPath.get(item, 'icon-only')) {
      cssClasses += ' kt-menu__item--icon-only';
    }

    if (this.isMenuItemIsActive(item)) {
      cssClasses += ' kt-menu__item--active';

      if (this.isTabMenuUsed && isRootLevel) {
        cssClasses += ' kt-menu__item--hover';
      }
    }

    if (this.isTabMenuUsed && isRootLevel) {
      cssClasses += ' kt-menu__item--tabs';
    }

    if (this.isTabMenuUsed && !isRootLevel && item.items.length) {
      cssClasses += ' kt-menu__item--submenu kt-menu__item--rel';
      if (depth && depth === 1) {
        cssClasses += ' kt-menu__item--submenu-tabs kt-menu__item--open-dropdown kt-menu__item--hover';
      }

    } else if (!this.isTabMenuUsed && item.items.length) {
      if (depth && depth >= 1) {
        cssClasses += ' kt-menu__item--submenu';
      } else {
        cssClasses += ' kt-menu__item--rel';
      }
    }

    return cssClasses;
  }

  getAnchorItemCssClasses(item, parentItem): string {
    let isRootLevel = item && !parentItem;
    let cssClasses = 'kt-menu__link';

    if ((this.isTabMenuUsed && isRootLevel) || item.items.length) {
      cssClasses += ' kt-menu__toggle';
    }

    return cssClasses;
  }

  getSubmenuCssClasses(item, parentItem, depth): string {
    let cssClasses = 'kt-menu__submenu kt-menu__submenu--classic';

    if (this.isTabMenuUsed) {
      if (depth === 0) {
        cssClasses += ' kt-menu__submenu--tabs';
      }

      cssClasses += ' kt-menu__submenu--' + (depth >= 2 ? 'right' : 'left');
    } else {
      cssClasses += ' kt-menu__submenu--' + (depth >= 1 ? 'right' : 'left');
    }

    return cssClasses;
  }

  isRootTabMenuItemWithoutChildren(item: any, isRootLevel: boolean): boolean {
    return this.isTabMenuUsed && isRootLevel && !item.items.length;
  }

  isMenuItemIsActive(item): boolean {
    if (item.items.length) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.route) {
      return false;
    }

    return item.route === this.currentRouteUrl;
  }

  isMenuRootItemIsActive(item): boolean {
    if (item.items) {
      for (const subItem of item.items) {
        if (this.isMenuItemIsActive(subItem)) {
          return true;
        }
      }
    }

    return false;
  }

  getItemAttrSubmenuToggle(menuItem, parentItem, depth) {
    let isRootLevel = menuItem && !parentItem;
    if (isRootLevel && this.isTabMenuUsed) {
      return 'tab';
    } else {
      if (depth && depth >= 1) {
        return 'hover';
      } else {
        return 'click';
      }
    }
  }

  getCssClass(): string {
    let menuCssClass = 'kt-header-menu kt-aside-header-menu-mobile kt-aside-header-menu-mobile--offcanvas kt-header-menu--skin-' + this.currentTheme.baseSettings.header.headerSkin;
    menuCssClass += ' kt-header-menu--submenu-skin-light';
    menuCssClass += ' kt-aside-header-menu-mobile--skin-light';
    menuCssClass += ' kt-aside-header-menu-mobile--submenu-skin-light';

    if (this.currentTheme.baseSettings.layout.layoutType === 'boxed') {
      return menuCssClass + ' kt-container--xxl';
    }

    return menuCssClass;
  }

  goTo(item: AppMenuItem): void {
    if (this.isDesktop) {
      this.changeTopbarItem.emit(item);
      this.router.navigate([item.items[0].route]);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.defineSize(event.target.innerWidth);
  }

  defineSize(innerWidth: number): void {
    this.isDesktop = false;
    if (innerWidth > 1024) {
      this.isDesktop = true;
    }
  }

  findActiveTopMenu(route, items): AppMenuItem {
    var routeArray = route.split("/");
    if (routeArray.length > 3) {
      let newRoute = "";
      for (let index = 1; index < 4; index++) {
        newRoute += "/" + routeArray[index];
      }
      var i = 0, found, result = [];
      for (; i < items.length; i++) {
        //Found Url
        if (items[i].route.includes(newRoute)) {
          return items[i];
        } else {
          found = this.findActiveTopMenu(route, items[i].items);
          if (found) {
            return items[i];
          }
        }
      }
      return null;
    }
    else {
      return null;
    }
  }
}
